import objectUtils from "../../util/objectUtils";
import axios from "axios";

export default {
    state: () => ({
        marketList : null,
        pricingMarketId : null,
    }),
    mutations: {
        setMarketList:function (state,marketList){
            state.marketList = marketList;
        },
        setPricingMarketId:function (state,pricingMarketId){
            state.pricingMarketId = pricingMarketId;
        },
    },
    getters: {
        getMarketList : state => {
            return state.marketList
        },
        getMarketMap : state => {
            let marketList = state.marketList;
            if(marketList == null)
                return null
            return marketList.reduce(function (map,market){
                map[market.id] = market
                return map
            },{})
        },
        getPricingMarketId : state => {
            return state.pricingMarketId
        },
    },
    actions:{
        loadMarketList(context){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.get(context.getters.getServiceUrl + "/admin-api/market", {headers})
                .then((response) => {
                    context.commit("setMarketList", response.data);
                    return response.data;
                })
        },
        updateMarket(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.put(context.getters.getServiceUrl + "/admin-api/market", request,{headers})
                .then((response) => {
                    let marketList = context.getters.getMarketList;
                    marketList.forEach((market) => {
                        if(response.data.id === market.id) {
                            objectUtils.deepCopy(market, response.data);
                        }
                    });

                    context.commit("setMarketList", marketList);
                    return response.data;
                })

        },
        createMarket(context, request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.post(context.getters.getServiceUrl + "/admin-api/market", request,{headers})
                .then((response) => {
                    let marketList = context.getters.getMarketList;
                    marketList.push(response.data);

                    context.commit("setMarketList", marketList);
                    return response.data;
                })
        },
        deleteMarket(context,request){
            const headers = {
                "Authorization": "Bearer " + context.getters.getToken.token,
            };
            return axios.delete(context.getters.getServiceUrl + "/admin-api/market/"+request.id,{headers})
                .then((response) => {
                    let marketList = context.getters.getMarketList;
                    marketList = marketList.filter(market=>{
                        return market.id !== request.id;
                    });
                    context.commit("setMarketList", marketList);
                    return response.data;
                })
        },
    }
}